import {
    ruCountryBy,
    ruCountryFor,
    ruCountryIn,
    ruCountryOf,
    ruCountryTo,
} from '@/i18n/countryCases';

export const faqSubpage = {
    en: {
        notFoundTitle: 'Page not found - TripLinkHub',
        notFoundDesc: 'The requested page does not exist',
        fallbackTitle: {
            esim: (name) => `eSIM Frequently Asked Questions for ${name}`,
            vpn: (name) => `VPN Frequently Asked Questions for ${name}`,
            tours: (name) => `FAQ: Tours & Excursions in ${name} - Complete Guide | TripLinkHub`,
            transport: (name) => `Transport Frequently Asked Questions for ${name}`,
        },
        fallbackDesc: {
            esim: (name) => `Complete list of answers to the most popular questions about how to choose, buy and use eSIM in ${name}.`,
            vpn: (name) => `Complete list of answers to the most popular questions about how to choose, set up and use VPN in ${name}.`,
            tours: (name) => `Complete guide to ${name} tours: how to choose best excursion, book a guide, what to see.`,
            transport: (name) => `Complete list of answers to the most popular questions about how to get around and use transport in ${name}.`,
        },
        keywords: {
            esim: (name) => [
                `esim ${name} faq`,
                `esim ${name} questions`,
                `how to use esim ${name}`,
                `esim for ${name} travel`,
                `${name} mobile internet`,
                `esim frequently asked questions`,
            ],
            vpn: (name) => [
                `vpn ${name} faq`,
                `vpn ${name} questions`,
                `how to use vpn ${name}`,
                `vpn for ${name} travel`,
                `${name} secure internet`,
                `vpn frequently asked questions`,
            ],
            tours: (name) => [
                `${name} tours faq`,
                `tours ${name} questions`,
                `${name} excursions guide`,
                `how to book tours ${name}`,
                `${name} travel tips`,
                `tours frequently asked questions`,
            ],
            transport: (name) => [
                `transport ${name} faq`,
                `transport ${name} questions`,
                `how to get around ${name}`,
                `${name} car rental`,
                `${name} transport guide`,
                `transport frequently asked questions`,
            ],
        },
        breadcrumbHome: 'Home',
        serviceLabel: { esim: 'eSIM', vpn: 'VPN', tours: 'Tours', transport: 'Transport' },
        contentTitle: {
            esim: (name) => `eSIM Frequently Asked Questions for ${name}`,
            vpn: (name) => `VPN Frequently Asked Questions for ${name}`,
            tours: (name) => `Frequently Asked Questions about Tours in ${name}`,
            transport: (name) => `Transport Frequently Asked Questions for ${name}`,
        },
        contentSubtitle: {
            esim: (name) => `Complete list of answers to the most popular questions about how to choose, buy and use eSIM in ${name}.`,
            vpn: (name) => `Complete list of answers to the most popular questions about how to choose, set up and use VPN in ${name}.`,
            tours: (name) => `Complete list of answers to the most popular questions about how to choose, book and enjoy the perfect tour in ${name}.`,
            transport: (name) => `Complete list of answers to the most popular questions about how to get around and use transport in ${name}.`,
        },
        toursBreadcrumbs: (country) => [
            { title: 'Home', href: '/en' },
            { title: 'Tours', href: `/en/${country}/tours` },
            { title: 'FAQ', href: `/en/${country}/tours/faq` },
        ],
    },
    ru: {
        notFoundTitle: 'Страница не найдена - TripLinkHub',
        notFoundDesc: 'Запрошенная страница не существует',
        fallbackTitle: {
            esim: (name) => `Часто задаваемые вопросы об eSIM ${ruCountryFor(name)}`,
            vpn: (name) => `Часто задаваемые вопросы о VPN ${ruCountryFor(name)}`,
            tours: (name) => `FAQ: Экскурсии и туры ${ruCountryIn(name)} - Ответы на все вопросы | TripLinkHub`,
            transport: (name) => `Часто задаваемые вопросы о транспорте ${ruCountryIn(name)}`,
        },
        fallbackDesc: {
            esim: (name) => `Полный список ответов на самые популярные вопросы о том, как выбрать, купить и использовать eSIM ${ruCountryIn(name)}.`,
            vpn: (name) => `Полный список ответов на самые популярные вопросы о том, как выбрать, настроить и использовать VPN ${ruCountryIn(name)}.`,
            tours: (name) => `Полный гайд по турам ${ruCountryIn(name)}: как выбрать лучшую экскурсию, забронировать гида, что посмотреть.`,
            transport: (name) => `Полный список ответов на самые популярные вопросы о том, как добраться, передвигаться и пользоваться транспортом ${ruCountryIn(name)}.`,
        },
        keywords: {
            esim: (name) => [
                `esim ${ruCountryOf(name)} вопросы`,
                `esim ${ruCountryOf(name)} часто задаваемые вопросы`,
                `как использовать esim ${ruCountryIn(name)}`,
                `esim для поездки ${ruCountryTo(name)}`,
                `мобильный интернет ${ruCountryIn(name)}`,
                `esim ответы на вопросы`,
            ],
            vpn: (name) => [
                `vpn ${ruCountryOf(name)} вопросы`,
                `vpn ${ruCountryOf(name)} часто задаваемые вопросы`,
                `как использовать vpn ${ruCountryIn(name)}`,
                `vpn для поездки ${ruCountryTo(name)}`,
                `безопасный интернет ${ruCountryIn(name)}`,
                `vpn ответы на вопросы`,
            ],
            tours: (name) => [
                `туры ${ruCountryIn(name)} вопросы`,
                `туры ${ruCountryIn(name)} часто задаваемые вопросы`,
                `экскурсии ${ruCountryIn(name)} гид`,
                `как забронировать туры ${ruCountryIn(name)}`,
                `советы путешественникам ${ruCountryBy(name)}`,
                `туры ответы на вопросы`,
            ],
            transport: (name) => [
                `транспорт ${ruCountryIn(name)} вопросы`,
                `транспорт ${ruCountryIn(name)} часто задаваемые вопросы`,
                `как добраться ${ruCountryTo(name)}`,
                `аренда авто ${ruCountryIn(name)}`,
                `транспортный гайд ${ruCountryBy(name)}`,
                `транспорт ответы на вопросы`,
            ],
        },
        breadcrumbHome: 'Главная',
        serviceLabel: { esim: 'eSIM', vpn: 'VPN', tours: 'Туры', transport: 'Транспорт' },
        contentTitle: {
            esim: (name) => `Часто задаваемые вопросы об eSIM ${ruCountryFor(name)}`,
            vpn: (name) => `Часто задаваемые вопросы о VPN ${ruCountryFor(name)}`,
            tours: (name) => `Часто задаваемые вопросы о турах ${ruCountryIn(name)}`,
            transport: (name) => `Часто задаваемые вопросы о транспорте ${ruCountryIn(name)}`,
        },
        contentSubtitle: {
            esim: (name) => `Полный список ответов на самые популярные вопросы о том, как выбрать, купить и использовать eSIM ${ruCountryIn(name)}.`,
            vpn: (name) => `Полный список ответов на самые популярные вопросы о том, как выбрать, настроить и использовать VPN ${ruCountryIn(name)}.`,
            tours: (name) => `Полный список ответов на самые популярные вопросы о том, как выбрать, забронировать и провести идеальный тур ${ruCountryIn(name)}.`,
            transport: (name) => `Полный список ответов на самые популярные вопросы о том, как добраться, передвигаться и пользоваться транспортом ${ruCountryIn(name)}.`,
        },
        toursBreadcrumbs: (country) => [
            { title: 'Главная', href: '/ru' },
            { title: 'Туры', href: `/ru/${country}/tours` },
            { title: 'FAQ', href: `/ru/${country}/tours/faq` },
        ],
    },
};

export const esimPromotions = {
    en: {
        metaTitle: (name) => `eSIM Promo Codes for ${name} - Discounts up to 15%`,
        metaDescription: (name) => `Active promo codes and discounts from eSIM providers for trips to ${name}. Save on internet with NEWTOAIRALO15, TRIPLINKTRAVEL, 15PROMO15 and more.`,
        ogImageAlt: (name) => `eSIM Promo Codes for ${name}`,
        twitterDescription: (name) => `Active promo codes and discounts from eSIM providers for trips to ${name}.`,
        contentTitle: (name) => `eSIM Promo Codes for ${name}`,
        contentDescription: (name) => `All active discounts and promo codes from eSIM providers for ${name}. Save money on internet while traveling.`,
        breadcrumbPromotions: 'Promotions',
        countryFrom: (name, price, data) => `Plans for ${name} from ${price}${data ? ` (${data})` : ''}.`,
        categoryAll: 'All Promotions',
        categoryNewCustomer: 'New Customers',
        categoryAllPlans: 'All Plans',
        freeShipping: 'Special offer',
        discount: 'Discount',
    },
    ru: {
        metaTitle: (name) => `Промокоды eSIM ${ruCountryFor(name)} - Скидки до 15%`,
        metaDescription: (name) => `Все актуальные промокоды и скидки от провайдеров eSIM для поездок ${ruCountryTo(name)}. Экономьте на интернете с NEWTOAIRALO15, TRIPLINKTRAVEL, 15PROMO15 и другими кодами.`,
        ogImageAlt: (name) => `Промокоды eSIM ${ruCountryFor(name)}`,
        twitterDescription: (name) => `Все актуальные промокоды и скидки от провайдеров eSIM для поездок ${ruCountryTo(name)}.`,
        contentTitle: (name) => `Промокоды eSIM ${ruCountryFor(name)}`,
        contentDescription: (name) => `Все действующие скидки и промокоды от провайдеров eSIM для поездки ${ruCountryTo(name)}. Экономьте на интернете в путешествиях.`,
        breadcrumbPromotions: 'Промокоды',
        countryFrom: (name, price, data) => `Тарифы ${ruCountryFor(name)} — от ${price}${data ? ` за ${data.replace('GB', 'ГБ').replace('MB', 'МБ')}` : ''}.`,
        categoryAll: 'Все акции',
        categoryNewCustomer: 'Для новых клиентов',
        categoryAllPlans: 'Все тарифы',
        freeShipping: 'Спецпредложение',
        discount: 'Скидка',
    },
};

export const esimDeviceCheck = {
    en: {
        metaTitle: 'eSIM Compatibility Check - Find out if your phone supports eSIM',
        metaDescription: (name) => `Check if your phone supports eSIM for traveling to ${name}. Select your device brand and model to learn about eSIM compatibility.`,
        metaKeywords: 'eSIM check, eSIM support, eSIM compatibility, eSIM devices, eSIM phones',
        ogTitle: (name) => `eSIM Compatibility Check for ${name} - TripLinkHub`,
        ogDescription: (name) => `Find out if your phone supports eSIM for traveling to ${name}. Simple device compatibility check.`,
        twitterTitle: 'eSIM Compatibility Check',
        twitterDescription: (name) => `Check your phone's eSIM compatibility for ${name}`,
        globalMetaDescription: 'Check if your phone supports eSIM. Select your device brand and model to learn about eSIM compatibility for travel.',
        globalOgTitle: 'eSIM Compatibility Check - TripLinkHub',
        globalOgDescription: 'Find out if your phone supports eSIM. Simple device compatibility check.',
        globalTwitterDescription: "Check your phone's eSIM compatibility",
    },
    ru: {
        metaTitle: 'Проверка поддержки eSIM - Узнайте, поддерживает ли ваш телефон eSIM',
        metaDescription: (name) => `Проверьте, поддерживает ли ваш телефон eSIM для поездки ${ruCountryTo(name)}. Выберите бренд и модель устройства, чтобы узнать о совместимости с eSIM.`,
        metaKeywords: 'eSIM проверка, поддержка eSIM, совместимость eSIM, eSIM устройства, eSIM телефоны',
        ogTitle: (name) => `Проверка поддержки eSIM ${ruCountryFor(name)} - TripLinkHub`,
        ogDescription: (name) => `Узнайте, поддерживает ли ваш телефон eSIM для поездки ${ruCountryTo(name)}. Простая проверка совместимости устройств.`,
        twitterTitle: 'Проверка поддержки eSIM',
        twitterDescription: (name) => `Проверьте совместимость вашего телефона с eSIM ${ruCountryFor(name)}`,
        globalMetaDescription: 'Проверьте, поддерживает ли ваш телефон eSIM. Выберите бренд и модель устройства, чтобы узнать о совместимости с eSIM для путешествий.',
        globalOgTitle: 'Проверка поддержки eSIM - TripLinkHub',
        globalOgDescription: 'Узнайте, поддерживает ли ваш телефон eSIM. Простая проверка совместимости устройств.',
        globalTwitterDescription: 'Проверьте совместимость вашего телефона с eSIM',
    },
};

export const esimQuiz = {
    en: {
        fallbackTitle: 'eSIM Finder - TripLinkHub',
        metaTitle: (name) => `eSIM Finder for ${name} - Find Your Perfect Plan`,
        metaDescription: (name) => `Take a short quiz and get personalized eSIM recommendations for your trip to ${name}. Compare plans, prices and features.`,
    },
    ru: {
        fallbackTitle: 'Подбор eSIM - TripLinkHub',
        metaTitle: (name) => `Подбор eSIM ${ruCountryFor(name)} - Найдите идеальный тариф`,
        metaDescription: (name) => `Пройдите короткий опрос и получите персональные рекомендации eSIM для поездки ${ruCountryTo(name)}. Сравнение тарифов, цен и условий.`,
    },
};

export const countryQuiz = {
    en: {
        fallbackTitle: 'Tour Finder - TripLinkHub',
        notFoundTitle: 'Quiz not found - TripLinkHub',
        notFoundDescription: 'Page not found',
        metaTitle: (name) => `Tour Finder for ${name} - Find Your Perfect Excursion`,
        metaDescription: (name) => `Take a short quiz and get personalized tour recommendations for your trip to ${name}.`,
    },
    ru: {
        fallbackTitle: 'Подбор тура - TripLinkHub',
        notFoundTitle: 'Квиз не найден - TripLinkHub',
        notFoundDescription: 'Страница не найдена',
        metaTitle: (name) => `Подбор тура ${ruCountryFor(name)} - Найдите идеальную экскурсию`,
        metaDescription: (name) => `Пройдите короткий опрос и получите персональные рекомендации туров для поездки ${ruCountryTo(name)}.`,
    },
};
